/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type SystemStatusDtoSeverity = typeof SystemStatusDtoSeverity[keyof typeof SystemStatusDtoSeverity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemStatusDtoSeverity = {
  NONE: 'NONE',
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
} as const;
